<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Neue Domain anlegen"
                :ok-disabled="!validate"
                :loading="loading"
                @ok="submit"
                @cancel="close">
            <Input v-model="name" label="Bezeichnung"
                   :error-messages="nameErrors"
                   :required="true"
                   @input="$v.name.$touch()"
                   @blur="$v.name.$touch()"></Input>
        </Dialog>
    </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Utils from "../../../scripts/Utils";
import Input from "../../../components/Inputs/Input";
import Dialog from "../../../components/Dialog";
import ada from "../../../scss/ada_colors.scss";

export default {
    name: "AddDomainDialog",
    components: {Dialog, Input},
    props: ['value'],
    mixins: [validationMixin],
    validations: {
        name: {required},
    },
    data: () => {
        return {
            name: null,
            loading: false,
            showDeleteDomainDialog: false,
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        nameErrors() {
            return Utils.handleError(this, 'name', 'Name ist erforderlich.');
        },
        validate() {
            return this.nameErrors.length === 0;
        }
    },
    methods: {
        init() {
            if (this.domain) {
                this.name = this.domain.Domain;
            } else {
                this.name = '';
            }
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                let data;
                try {
                    data = await this.$store.dispatch('display/editDomain', this.getBody());
                    this.loading = false;
                    if (data.Status) {
                        this.$root.$emit('snackbar', 'Domain erfolgreich angelegt')
                        this.close();
                    }
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        getBody() {
            let json = {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                domain: this.name
            };
            if (this.domain) {
                json.domain_id = this.domain.SitetypeDomainId
            }
            return json
        },
        close() {
            this.init();
            this.$emit('input', false); // set v-model to false -> close dialog
        }
    },
    watch: {
        domain() {
            this.init();
        }
    }
}
</script>

<style lang="scss" scoped>

::v-deep tbody tr {
    cursor: pointer;
}

</style>